<template>
  <div>

    <!-- form report -->
    <b-card style="position: relative">

      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">


          <b-col cols="6">
            <b-form-group :label="$t('plan type')" label-for="vi-plan_type-id">
              <v-select v-model="request.plan_type" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{name: $t('dump'), id: 'dump'},{name:$t('wash'),id:'wash'}]"
                :reduce="d => d.id" v-on:input="filterPlans(request.plan_type)" />
              <small v-if="errors && ('plan_type' in errors)" class="text-danger">
                {{ $t(errors['plan_type'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <!-- devices  -->
          <b-col cols="6">
            <b-form-group :label="$t('plans')" label-for="vi-plan-id">
              <v-select multiple :close-on-select="false" v-model="request.plans" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{name: $t('all'), id: 'all'},...plans]" :reduce="d => d.id" />
              <small v-if="errors && ('plans' in errors)" class="text-danger">
                {{ $t(errors['plans'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <b-col md="12" sm="12">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>







        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="loading"
        :getReport="getReport" :total="total" :from="from" :to="to" :sortData="sortData" />

    </div>

  </div>

</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, computed } from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import Cleave from 'vue-cleave-component'
import reportForm from '@/app/reports/containerPlan/reportForm'
import ContainerReportLogic from '@/app/reports/containerPlan/logic'
import { ExportDataServices } from '@/share/reports/exportService'



import ReportOptions from '@/views/reports/components/options.js'

import DataTable from '@/views/reports/data-table/DataTable.vue'
export default {
  name: 'CompactorReport',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    Cleave,
    BLink,
    BMedia,
    DataTable
  },
  directives: { Ripple, },

  setup(props, { root }) {

    const rangeDate = ref('')


    const tableRef = ref(null)
    const { plans, filterPlans } = reportForm()

    const { report_data, request, errors, loading, getReport, getReportForPdf, total, from, to,isSortDirDesc,sortBy } = ContainerReportLogic()

    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }

    const perPageOptions = [5, 10, 25, 50, 100]
    const { pickerOptions } = ReportOptions(request.value)


    const report_wrapper = ref(null)

    const filter_included_fields = ['device', 'plan', 'start', 'end', 'owner', 'contract'];
    const report_fields = [
      {
        key: 'index',
        label: 'id',
       
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },

      {
        key: 'device',
        label: 'device',
        sortable: true
      },
      {
        key: 'plan',
        label: 'plan',
        sortable: true
      },
      {
        key: 'start',
        label: 'plan start',
        sortable: false
      },
      {
        key: 'end',
        label: 'plan end',
        sortable: false
      },
      {
        key: 'in_plan',
        label: 'Planned',
        sortable: false
      },
      {
        key: 'out_plan',
        label: 'out plan',
        sortable: false
      },
      {
        key: 'workdays',
        label: 'workdays',
        sortable: false
      },
      {
        key: 'percent',
        label: 'percent',
        sortable: false
      },
     

    ]









    return {
      report_data, filter_included_fields, report_fields, total, from, to, rangeDate,
      tableRef,
      getReport,
      perPageOptions,

      plans,
      filterPlans,
      getReportForPdf,
      pickerOptions,
      report_wrapper,


      request,
      loading,
      errors,
      sortData,
      // isNamePresent,

    }


  },



}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
